<template lang="html">

  <section class="noticia-el" :destacada="data.destacada == 1">

    <div class="contenedor-imagen">
      <!-- <router-link class="categoria" :to="`${$t('enlaces.categorias')}/${data.categoria.slug}`">
        {{data.categoria.nombre}}</router-link> -->
        <span class="categoria">{{data.categoria.slug}}</span>
      <img :src="data.img.enlace" :alt="data.titulo">

    </div>

    <h3 class="fecha">{{data.fecha.day}} {{$t(`meses[${Number(data.fecha.month)-1}]`)}} de {{data.fecha.year}}</h3>

    <h2 class="titulo">{{data.titulo}}</h2>

    <p class="entradilla">{{data.entradilla}}</p>

    <router-link class="enlace-cover" :to="`${$t('enlaces.noticia')}/${data.slug}`"></router-link>


  </section>

</template>

<script lang="js">

  import { mapGetters } from 'vuex';

  export default {
    name: 'noticia',
    props: ['data'],
  }
</script>


// WEBPACK FOOTER //
// src/components/parts/noticia-el.vue